export default __webpack_public_path__ + "static/media/selecta_small@2x.ecb67f39.jpg";